exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-107fee20]  .dialog_box{border-radius:10px}.box[data-v-107fee20]  .dialog_box .el-dialog__header{border-radius:10px 10px 0 0;background:#ecf4ff;color:#282828;font-weight:600;font-size:22px}.box .from_box[data-v-107fee20]{padding:0 80px}.long-text[data-v-107fee20]{text-overflow:-o-ellipsis-lastline;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.in-box[data-v-107fee20]{display:inline-block;font-size:10px}.active-btn[data-v-107fee20]{background:#1890ff !important;color:#fff !important}", ""]);

// exports
